import { vectorTileLayer } from 'esri-leaflet-vector';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { config } from '../../../config';

type Props = {
  token?: string;
};

export const BaseMapLayer: React.FC<Props> = ({ token }) => {
  const map = useMap();

  useEffect(() => {
    vectorTileLayer(config.arcgis.baseMapLayer, { token }).addTo(map);
  }, []);

  return null;
};
